import checkInputs from "utils/checkInputs";
//Valida los campos que se encuentran en la seccion 6.8.1. Información del Pedido Comercial Relacionadas con la Factura
export const validationComercialOrderInvoice = {

    onChange: function checkOnChange(nameInput, value) {
        const response = { value: value, error: null, keyWordError: null };
        switch (nameInput) {
            case "codigoCliente":
            case "informacionInteres":
            case "nroAceptacion":
            case "nroPedidoCompra":
                if (!checkInputs.notNull(value)) {
                    response.keyWordError = "isNull";
                    response.error = "Ingresar el número de pedido de compra, es necesario.";
                }
                return response;

            default:
                return response;
        }

    },
    onSubmit: function checkOnSubmit(data) {
        const errors = {};

        if (!checkInputs.notNull(data.nroPedidoCompra)) {
            errors.nroPedidoCompra = "Ingresar el número de pedido de compra, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.nroPedidoCompra)) {
            errors.nroPedidoCompra = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.nroPedidoCompra) > 12 || checkInputs.countLenth(data.nroPedidoCompra) < 1) {
            errors.nroPedidoCompra = "Ingresar entre 1 y 12 caracteres.";

        }

        if (checkInputs.notNull(data.codigoCliente)) {
            if (!checkInputs.isAlphanumeric(data.codigoCliente)) {
                errors.codigoCliente = "Ingresar solo caracteres alfanuméricos.";
            } else if (checkInputs.countLenth(data.codigoCliente) > 50 || checkInputs.countLenth(data.codigoCliente) < 1) {
                errors.codigoCliente = "Ingresar entre 1 y 50 caracteres.";
            }
        }

        if (checkInputs.notNull(data.informacionInteres)) {
            if (!checkInputs.isAlphanumeric(data.informacionInteres)) {
                errors.informacionInteres = "Ingresar solo caracteres alfanuméricos.";
            } else if (checkInputs.countLenth(data.informacionInteres) > 5000 || checkInputs.countLenth(data.informacionInteres) < 1) {
                errors.informacionInteres = "Ingresar entre 1 y 5000 caracteres.";
            }
        }

        // if (checkInputs.notNull(data.nroAceptacion)) {
        //     if (!checkInputs.isAlphanumeric(data.nroAceptacion)) {
        //         errors.nroAceptacion = "Ingresar solo caracteres alfanuméricos.";
        //     }
        // }
        return errors;
    },
}

//Valida los campos que se encuentran en la seccion 6.8.2. Información de Logística
export const validationLogisticOrderInvoice = {

    onSubmit: function checkOnSubmit(data) {
        const errors = {};

        if (!checkInputs.notNull(data.nombreTransportista)) {
            errors.nombreTransportista = "Ingresar el nombre o razón social del transportista, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.nombreTransportista)) {
            errors.nombreTransportista = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.nombreTransportista) > 100 || checkInputs.countLenth(data.nombreTransportista) < 15) {
            errors.nombreTransportista = "Ingresar entre 15 y 100 caracteres.";
        }

        if (!checkInputs.notNull(data.tipoRuc)) {
            errors.tipoRuc = "Ingresar el tipo de contribuyente, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.tipoRuc)) {
            errors.tipoRuc = "Ingresar solo caracteres alfanuméricos.";
        }

        if (!checkInputs.notNull(data.ruc)) {
            errors.ruc = "Ingresar el RUC , es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.ruc)) {
            errors.ruc = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.ruc) > 20 || checkInputs.countLenth(data.ruc) < 5) {
            errors.ruc = "Ingresar entre 5 y 20 caracteres.";
        }

        if (!checkInputs.notNull(data.dv)) {
            errors.dv = "Ingresar el dígito verificador, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.dv)) {
            errors.dv = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.dv) != 2) {
            errors.ruc = "Ingresar 2 caracteres.";
        }

        if (checkInputs.notNull(data.nrovolumenes)) {
            if (!checkInputs.isDecimal(data.nrovolumenes)) {
                errors.nrovolumenes = "Ingresar solo números.";
            } else if (checkInputs.countLenth(data.nrovolumenes) > 3 || checkInputs.countLenth(data.nrovolumenes) < 1) {
                errors.nrovolumenes = "Ingresar entre 1 y 3 dígitos.";
            }
        }

        if (checkInputs.notNull(data.pesoCarga)) {
            if (!checkInputs.isDecimal(data.pesoCarga)) {
                errors.pesoCarga = "Ingresar solo números.";
            }
        }

        if (checkInputs.notNull(data.licenciaVehiculo)) {
            if (!checkInputs.isAlphanumeric(data.licenciaVehiculo)) {
                errors.licenciaVehiculo = "Ingresar solo caracteres alfanuméricos.";
            } else if (checkInputs.countLenth(data.licenciaVehiculo) != 6) {
                errors.licenciaVehiculo = "Ingresar 6 caracteres.";
            }
        }

        if (checkInputs.notNull(data.informacionInteres)) {
            if (!checkInputs.isAlphanumeric(data.informacionInteres)) {
                errors.informacionInteres = "Ingresar solo caracteres alfanuméricos.";
            } else if (checkInputs.countLenth(data.informacionInteres) > 5000) {
                errors.informacionInteres = "Ingresar máximo 5000 caracteres.";
            }
        }
        return errors;
    },
}

//Valida los campos que se encuentran en la seccion 6.8.3. Identificación del Local de Entrega
export const validationDeliveryLocationInvoice = {

    onSubmit: function checkOnSubmit(data) {
        const errors = {};

        if (!checkInputs.notNull(data.nombreLocalEntrega)) {
            errors.nombreLocalEntrega = "Ingresar el nombre o razón social del local de entrega, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.nombreLocalEntrega)) {
            errors.nombreLocalEntrega = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.nombreLocalEntrega) > 100 || checkInputs.countLenth(data.nombreLocalEntrega) < 2) {
            errors.nombreLocalEntrega = "Ingresar entre 2 y 100 caracteres.";
        }

        if (!checkInputs.notNull(data.ruc)) {
            errors.ruc = "Ingresar el RUC , es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.ruc)) {
            errors.ruc = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.ruc) > 20 || checkInputs.countLenth(data.ruc) < 5) {
            errors.ruc = "Ingresar entre 2 y 100 caracteres.";
        }

        if (!checkInputs.notNull(data.tipoRuc)) {
            errors.tipoRuc = "Ingresar el tipo de contribuyente, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.tipoRuc)) {
            errors.tipoRuc = "Ingresar solo caracteres alfanuméricos.";
        }

        if (!checkInputs.notNull(data.dv)) {
            errors.dv = "Ingresar el dígito verificador, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.dv)) {
            errors.dv = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.dv) != 2) {
            errors.dv = "Ingresar 2 caracteres.";
        }

        if (!checkInputs.notNull(data.direccionLocalEntrega)) {
            errors.direccionLocalEntrega = "Ingresar la dirección del local de la entrega , es necesaria.";
        } else if (!checkInputs.isAlphanumeric(data.direccionLocalEntrega)) {
            errors.direccionLocalEntrega = "Ingresar solo caracteres alfanuméricos.";
        } else if (checkInputs.countLenth(data.direccionLocalEntrega) > 100) {
            errors.direccionLocalEntrega = "Ingresar máximo 100 caracteres.";
        }

        if (!checkInputs.notNull(data.provincia)) {
            errors.provincia = "Ingresar la provincia, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.provincia)) {
            errors.provincia = "Ingresar solo caracteres alfanuméricos.";
        }

        if (!checkInputs.notNull(data.distrito)) {
            errors.distrito = "Ingresar el distrito, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.distrito)) {
            errors.distrito = "Ingresar solo caracteres alfanuméricos.";
        }

        if (!checkInputs.notNull(data.corregimiento)) {
            errors.corregimiento = "Ingresar el corregimiento es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.corregimiento)) {
            errors.corregimiento = "Ingresar solo caracteres alfanuméricos.";
        }

        if (checkInputs.notNull(data.telefonoLocalEntrega)) {
            if (!checkInputs.isAlphanumeric(data.telefonoLocalEntrega)) {
                errors.telefonoLocalEntrega = "Ingresar solo caracteres alfanuméricos.";
            } else if (checkInputs.countLenth(data.telefonoLocalEntrega) > 12 || checkInputs.countLenth(data.telefonoLocalEntrega) < 7) {
                errors.telefonoLocalEntrega = "Ingresar entre 7 y 12 caracteres.";
            }
        }

        if (checkInputs.notNull(data.telefonoAdicionalLocalEntrega)) {
            if (!checkInputs.isAlphanumeric(data.telefonoAdicionalLocalEntrega)) {
                errors.telefonoAdicionalLocalEntrega = "Ingresar solo caracteres alfanuméricos.";
            } else if (checkInputs.countLenth(data.telefonoAdicionalLocalEntrega) > 12 || checkInputs.countLenth(data.telefonoAdicionalLocalEntrega) < 7) {
                errors.telefonoAdicionalLocalEntrega = "Ingresar entre 7 y 12 caracteres.";
            }
        }

        return errors;
    },
}

//Valida los campos de exportacion en caso de que sea factura de exportacion
export const validationExportInvoice = {

    onSubmit: function checkOnSubmit(data) {
        const errors = {};

        if (!checkInputs.notNull(data.nombreTransportista)) {
            errors.nombreTransportista = "Ingresar el nombre o razón social del transportista, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.nombreTransportista)) {
            errors.nombreTransportista = "Ingresar solo caracteres alfanuméricos.";
        }

        if (!checkInputs.notNull(data.tipoRuc)) {
            errors.tipoRuc = "Ingresar el tipo de contribuyente, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.tipoRuc)) {
            errors.tipoRuc = "Ingresar solo caracteres alfanuméricos.";
        }

        if (!checkInputs.notNull(data.ruc)) {
            errors.ruc = "Ingresar el RUC , es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.ruc)) {
            errors.ruc = "Ingresar solo caracteres alfanuméricos.";
        }

        if (!checkInputs.notNull(data.dv)) {
            errors.dv = "Ingresar el dígito verificador, es necesario.";
        } else if (!checkInputs.isAlphanumeric(data.dv)) {
            errors.dv = "Ingresar solo caracteres alfanuméricos.";
        }

        if (checkInputs.notNull(data.nrovolumenes)) {
            if (!checkInputs.isDecimal(data.nrovolumenes)) {
                errors.nrovolumenes = "Ingresar solo números.";
            }
        }

        if (checkInputs.notNull(data.pesoCarga)) {
            if (!checkInputs.isDecimal(data.pesoCarga)) {
                errors.pesoCarga = "Ingresar solo números.";
            }
        }

        if (checkInputs.notNull(data.licenciaVehiculo)) {
            if (!checkInputs.isAlphanumeric(data.licenciaVehiculo)) {
                errors.licenciaVehiculo = "Ingresar solo caracteres alfanuméricos.";
            }
        }

        if (checkInputs.notNull(data.informacionInteres)) {
            if (!checkInputs.isAlphanumeric(data.informacionInteres)) {
                errors.informacionInteres = "Ingresar solo caracteres alfanuméricos.";
            }
        }
        return errors;
    },
}